<template>
  <div
    :class="{
      'single-product--catalog': variant === 'catalog',
      'single-product--horizontal': productCardLayout === 'horizontal' && !['overlay', 'category-showcase'].includes(activeProductTemplate),
      'single-product--template-overlay': activeProductTemplate === 'overlay',
      'single-product--category-showcase': activeProductTemplate === 'category-showcase'
    }"
  >
    <div
      class="h-100 click py-2"
      v-if="p._id"
      @click="view()"
      :tabindex="variant === 'catalog' || activeProductTemplate === 'category-showcase' ? 0 : null"
      :role="variant === 'catalog' || activeProductTemplate === 'category-showcase' ? 'button' : null"
      :aria-label="variant === 'catalog' || activeProductTemplate === 'category-showcase' ? `Ver ${p.name}` : null"
      @keydown.enter="view()"
      @keydown.space.prevent="view()"
      style="min-width: 160px; max-width: 100%; width: 100%"
    >
      <div class="border single-product-card">
        <b-img-lazy
          class="img-fluid w-100"
          :src="getImage(p.image, 'small')"
          :alt="p.name"
        ></b-img-lazy>
      </div>

      <div class="px-2 py-1 position-relative product-info">
        <div
          class="badge badge-info rounded-0 py-2 position-absolute px-3 promo-badge"
          style="top: -90px; left: 0px"
          v-if="getPromoSummary(p)"
        >
          <span> {{ getPromoSummary(p) }} </span>
          <span class="d-none promo-detail">{{ getPromo(p.value, p.promos) }}</span>
        </div>
        <div
          class="badge rounded-0 py-2 position-absolute px-3 availability-badge"
          style="top: -90px; right: 0px"
          v-if="hasExclusiveAvailability"
        >
          <span>{{ getAvailable(p.available_on) }}</span>
        </div>
        <div
          class="badge badge-warning rounded-0 py-2 position-absolute w-100 category-badge"
          style="top: -120px; left: 0px"
          v-if="p.stock !== false && p.stock < 1"
        >
          <span> SIN STOCK </span>
        </div>
        <div
          class="badge badge-secondary rounded-0 position-absolute px-3 badge-price badge-category"
        >
          <span class="category-text">
            {{ (p.category && p.category.name) || "Sin Categoria" }}
          </span>
        </div>
        <div
          class="badge badge-danger rounded-0 product-price-badge"
          
        >
          <small
            class="d-block text-secondary px-2"
            v-if="getCardDiscountedPrice(p) < p.value"
          >
            <s>${{ formatNumber(p.value) }}</s>
          </small>
          <span class="d-block px-2">
            ${{ formatNumber(getCardDiscountedPrice(p)) }}
          </span>
        </div>
        <div class="overflow-hidden product-name">
          <span
            class="card-title text-uppercase font-weight-bold pr-2 product-title"
          >
            {{ p.name }}
          </span>
        </div>
        <p v-if="activeProductTemplate !== 'overlay' && (variant === 'catalog' || productCardLayout === 'horizontal' || activeProductTemplate === 'category-showcase') && p.description" class="product-description">{{ plainDescription }}</p>
        <span v-if="variant === 'catalog'" class="catalog-card-action" aria-hidden="true">
          <b-icon icon="cart" />
        </span>
      </div>
      <div class="align-self-end w-100 px-2 mb-2 d-none">
        <div class="row">
          <div class="col-md-5 ml-auto">
            <router-link
              class="btn btn-outline-success text-center d-block btn-sm"
              :to="getLink(`producto/${p._id}`)"
            >
              <b-icon icon="cart" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: [String, Number],
      default: null,
    },
    variant: {
      type: String,
      default: "",
    },
    productTemplate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      p: {},
    };
  },
  computed: {
    activeProductTemplate() {
      const settings = this.$store.state.info && this.$store.state.info.settings;
      const template = this.productTemplate || (settings && settings.productCardTemplate);
      return ["overlay", "category-showcase"].includes(template) ? template : "default";
    },
    productCardLayout() {
      const settings = this.$store.state.info && this.$store.state.info.settings;
      const configuredLayout = settings && settings.productCardLayoutConfigured === true
        ? settings.productCardLayout
        : null;
      if (configuredLayout === "vertical" || configuredLayout === "horizontal") {
        return configuredLayout;
      }

      const legacyLayout = settings && settings.singleProductLayout;
      if (legacyLayout === "vertical" || legacyLayout === "horizontal") {
        return legacyLayout;
      }

      return "horizontal";
    },
    plainDescription() {
      return String(this.p.description || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    },
    hasExclusiveAvailability() {
      return !!(
        this.p &&
        this.p.available_on &&
        this.getAvailable(this.p.available_on)
      );
    },
  },
  mounted() {
    if (!this.data) this.load();
    else this.p = this.data;
  },
  methods: {
    isPromoActiveForQty(promo = {}, qty = 1) {
      if (!promo || !promo.enabled) return false;
      if (promo.when == "qty") return this.checkCondition(qty, promo.is, promo.value);
      if (!promo.when) return true;
      return promo.when != "total" && promo.when != "minopcion";
    },
    getPromoSummary(product = {}) {
      const promos = (product.promos || []).filter((promo) => promo && promo.enabled);
      if (promos.length === 0) return "";

      const [promo] = promos;
      if (promo.to == "product") {
        if (promo.when == "qty" && Number(promo.value) > 1) {
          if (promo.in == "%") return `${promo.discount}% dcto desde ${promo.value} un.`;
          return `-$${this.formatNumber(promo.discount)} desde ${promo.value} un.`;
        }

        if (promo.in == "%") {
          return `Ahora $${this.formatNumber(product.value - (product.value * promo.discount) / 100)}`;
        }

        return `Ahora $${this.formatNumber(product.value - promo.discount)}`;
      }
      if (promo.to == "total" && promo.when == "qty") {
        if (promo.in == "%") return `${promo.discount}% dcto desde ${promo.value} un.`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} desde ${promo.value} un.`;
      }
      if (promo.to == "total" && promo.when == "total") {
        if (promo.in == "%") return `${promo.discount}% dcto sobre $${this.formatNumber(promo.value)}`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} sobre $${this.formatNumber(promo.value)}`;
      }
      if (promo.to == "option") {
        if (promo.in == "%" && Number(promo.discount) === 100) {
          return promo.value
            ? `Extra gratis desde $${this.formatNumber(promo.value)}`
            : "Extra gratis";
        }
        return promo.when == "minopcion" && promo.value
          ? `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en extras`
          : `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en opciones`;
      }
      return "Oferta";
    },
    getCardDiscountedPrice(product = {}) {
      const promos = Array.isArray(product.promos)
        ? product.promos.filter((promo) => promo && promo.enabled)
        : [];
      const baseValue = Number(product.value) || 0;
      const promo = promos.find((item) => item && item.enabled);

      if (!promo) return baseValue;
      if (!this.isPromoActiveForQty(promo, 1)) return baseValue;

      if (promo.to == "product") {
        if (promo.in == "%") {
          return Math.max(
            baseValue - baseValue * ((Number(promo.discount) || 0) / 100),
            0
          );
        }

        return Math.max(baseValue - (Number(promo.discount) || 0), 0);
      }

      if (
        promo.to == "total" &&
        promo.when == "qty" &&
        Number(promo.value) <= 1
      ) {
        if (promo.in == "%") {
          return Math.max(
            baseValue - baseValue * ((Number(promo.discount) || 0) / 100),
            0
          );
        }

        if (promo.in == "$") {
          return Math.max(baseValue - (Number(promo.discount) || 0), 0);
        }
      }

      return baseValue;
    },
    getAvailable(values) {
      let rs = "";

      if (values.length == 1) {
        const [value] = values;
        if (value == "pickup") rs = "Solo retiro";
        if (value == "delivery") rs = "Solo Delivery";
        if (value == "shipping") rs = "Solo Envio";
      } 
      //else {
      //   values.forEach((value) => {
      //     if (value == "pickup") rs += "Retiro";
      //     if (value == "delivery") rs += "Relivery";
      //     if (value == "shipping") rs += "Envio";
      //   });
      // }

      return rs;
    },
    getPromo(value = 0, promos) {
      let rs = "";

      promos.forEach((promo) => {
        if (!promo.enabled) return;
        if (promo.to == "product") {
          const targetPrice = promo.in == "%"
            ? Math.max(value - value * ((Number(promo.discount) || 0) / 100), 0)
            : Math.max(value - (Number(promo.discount) || 0), 0);
          if (promo.when == "qty" && Number(promo.value) > 1) {
            rs += `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} desde ${promo.value} un.` + " \n";
          } else {
            rs += `$${this.formatNumber(targetPrice)} sobre $${this.formatNumber(value)}` + " \n";
          }
        }
        if (promo.to == "total")
          rs += `-$${promo.discount} al total sobre $${promo.value}` + " \n";
        if (promo.to == "option")
          rs += (
            promo.when == "minopcion" && promo.value
              ? `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en extras desde $${this.formatNumber(promo.value)}`
              : `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en opciones extra`
          ) + " \n";
        // console.log({ promo });
      });
      return rs;
    },
    view() {
      console.log("uwu");
      // push query pid
      this.$router.push({
        query: { pid: this.p._id },
      });
    },
    load() {
      const pid = this.id;
      const { webName: _id } = this.$store.state.info;
      this.$http
        .get(`${_id}/product/${pid}`)
        .then((res) => {
          this.p = res.data.data;
          //this.$store.commit("setProduct", res.data.data);
          console.log(res.data.data);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.single-product-card {
  max-width: 360px;
  margin: 0 auto;
}

.single-product--horizontal > .click {
  display: flex;
  align-items: stretch;
  min-width: 0 !important;
  overflow: hidden;
}

.single-product--horizontal .single-product-card {
  flex: 0 0 40%;
  max-width: 40%;
  margin: 0;
  overflow: hidden;
}

.single-product--horizontal .single-product-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.single-product--horizontal .product-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  padding: 0.85rem !important;
}

.single-product--horizontal .product-description {
  order: 2;
  display: -webkit-box;
  overflow: hidden;
  margin: 0 0 0.5rem;
  color: #64748b;
  font-size: 0.85rem;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.single-product--horizontal .product-price-badge {
  order: 3;
  align-self: flex-start;
  margin-top: auto;
}

.single-product--horizontal .promo-badge,
.single-product--horizontal .availability-badge,
.single-product--horizontal .category-badge {
  position: static !important;
  width: auto !important;
  margin: 0 0 0.4rem;
}

.single-product--horizontal .badge-category {
  position: static !important;
  max-width: 100%;
}

.availability-badge {
  background: #bfdbfe;
  color: #1e3a8a;
  border: 1px solid rgba(59, 130, 246, 0.22);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  max-width: 140px;
  white-space: normal;
  text-align: center;
  z-index: 3;
}

.product-price-badge {
  z-index: 4;
  min-width: 96px;
  text-align: center;
}

.product-title {
  display: block;
  line-height: 1.15;
  font-size: 1.05rem;
}

.single-product--catalog > .click {
  display: flex;
  flex-direction: column;
  min-width: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid #e4e7df;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(25, 47, 34, 0.05);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.single-product--catalog > .click:hover,
.single-product--catalog > .click:focus-visible {
  transform: translateY(-4px);
  box-shadow: 0 18px 38px rgba(25, 47, 34, 0.13);
}

.single-product--catalog > .click:focus-visible {
  outline: 3px solid #688a69;
  outline-offset: 3px;
}

.single-product--catalog .single-product-card {
  width: 100%;
  max-width: none;
  margin: 0;
  overflow: hidden;
  border: 0 !important;
  aspect-ratio: 2.15 / 1;
  background: #f3f4ef;
}

.single-product--catalog .single-product-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 300ms ease;
}

.single-product--catalog > .click:hover .single-product-card img {
  transform: scale(1.04);
}

.single-product--catalog .product-info {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 154px;
  padding: 12px 64px 15px 14px !important;
}

.single-product--catalog .badge-category {
  top: -36px;
  left: 12px;
  max-width: calc(100% - 24px);
  overflow: hidden;
  border-radius: 999px !important;
  background: #e8f1ff;
  color: #315883;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.single-product--catalog .product-name {
  order: 1;
  margin-bottom: 8px;
}

.single-product--catalog .product-title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #152a4b;
  font-size: 0.96rem;
  line-height: 1.3;
}

.single-product--catalog .product-price-badge {
  order: 2;
  align-self: flex-start;
  min-width: 0;
  margin-top: auto;
  padding: 6px 10px;
  border-radius: 999px !important;
  background: #b94f28;
  font-size: 0.9rem;
}

.single-product--catalog .product-price-badge .text-secondary {
  color: rgba(255, 255, 255, 0.75) !important;
}

.single-product--catalog .product-description {
  display: -webkit-box;
  order: 2;
  overflow: hidden;
  margin: 0 0 8px;
  color: #667995;
  font-size: 0.78rem;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.single-product--catalog .product-price-badge {
  order: 3;
  margin-top: auto;
}

.catalog-card-action {
  position: absolute;
  right: 13px;
  bottom: 13px;
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 50%;
  background: #e5f0ff;
  color: #0876e9;
  font-size: 1.05rem;
  box-shadow: 0 4px 11px rgba(20, 120, 237, 0.09);
}

@media (max-width: 991.98px) {
  .single-product-card {
    max-width: 100%;
  }
}

@media (max-width: 575.98px) {
  .promo-badge,
  .availability-badge,
  .category-badge,
  .product-price-badge {
    position: static !important;
    display: inline-flex;
    width: auto !important;
    margin: 0.25rem 0.35rem 0.1rem 0;
  }

  .product-price-badge {
    justify-content: center;
    min-width: 120px;
  }

  .product-title {
    margin-top: 0.35rem;
    font-size: 1rem;
    line-height: 1.1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .single-product--catalog .badge-category {
    position: absolute !important;
    top: -36px;
    left: 10px;
    width: auto !important;
    margin: 0;
  }

  .single-product--catalog .product-info {
    min-height: 145px;
    padding: 12px 60px 13px 12px !important;
  }

  .single-product--catalog .product-price-badge {
    min-width: 0;
    margin: auto 0 0;
  }

  .catalog-card-action {
    right: 10px;
    bottom: 11px;
    width: 38px;
    height: 38px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .single-product--catalog > .click,
  .single-product--catalog .single-product-card img {
    transition: none;
  }
}
.single-product--catalog.single-product--horizontal > .click {
  flex-direction: row;
}

.single-product--catalog.single-product--horizontal .single-product-card {
  flex: 0 0 40%;
  width: 40%;
  max-width: 40%;
  aspect-ratio: auto;
}

.single-product--catalog.single-product--horizontal .product-info {
  min-height: 160px;
}

.single-product--catalog.single-product--horizontal .badge-category {
  position: static !important;
  margin-bottom: 0.5rem;
}

.single-product--catalog.single-product--horizontal .product-description {
  order: 2;
}

.single-product--catalog.single-product--horizontal .product-price-badge {
  order: 3;
  margin-top: auto;
}

@media (max-width: 575.98px) {
  .single-product--horizontal .single-product-card {
    flex-basis: 36%;
    max-width: 36%;
  }
}

.single-product--template-overlay > .click {
  position: relative;
  display: block;
  min-width: 0 !important;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  padding: 0 !important;
  border: 0;
  border-radius: 30px;
  background: #26221f;
  box-shadow: 0 10px 22px rgba(34, 24, 24, 0.2);
  isolation: isolate;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.single-product--template-overlay > .click:hover,
.single-product--template-overlay > .click:focus-visible {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(34, 24, 24, 0.27);
}

.single-product--template-overlay > .click:focus-visible {
  outline: 3px solid #d9859e;
  outline-offset: 3px;
}

.single-product--template-overlay .single-product-card {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  margin: 0;
  overflow: hidden;
  border: 0 !important;
  border-radius: inherit;
  background: #eee5dc;
}

.single-product--template-overlay .single-product-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 350ms ease;
}

.single-product--template-overlay > .click:hover .single-product-card img {
  transform: scale(1.045);
}

.single-product--template-overlay .product-info {
  position: absolute !important;
  z-index: 2;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  min-height: 104px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 2.8rem 0.65rem 0.8rem !important;
  background: linear-gradient(180deg, transparent 0%, rgba(8, 8, 8, 0.52) 42%, rgba(8, 8, 8, 0.94) 100%);
  color: #fff;
  text-align: center;
}

.single-product--template-overlay .badge-category {
  display: none;
}

.single-product--template-overlay .product-price-badge {
  position: static !important;
  order: 0;
  min-width: 0;
  margin: 0 0 0.2rem;
  padding: 0 !important;
  border: 0;
  background: transparent !important;
  color: #fff;
  font-size: 1.12rem;
  font-weight: 800;
  line-height: 1.1;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.55);
}

.single-product--template-overlay .product-price-badge .text-secondary {
  padding: 0 !important;
  color: rgba(255, 255, 255, 0.78) !important;
  font-size: 0.72rem;
}

.single-product--template-overlay .product-price-badge > span {
  padding: 0 !important;
}

.single-product--template-overlay .product-name {
  order: 1;
  width: 100%;
  overflow: visible;
}

.single-product--template-overlay .product-title {
  display: -webkit-box;
  overflow: hidden;
  padding: 0;
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(0.83rem, 1.15vw, 1.04rem);
  font-weight: 900;
  letter-spacing: 0.015em;
  line-height: 1.1;
  text-align: center;
  text-overflow: ellipsis;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.single-product--template-overlay .promo-badge,
.single-product--template-overlay .availability-badge {
  position: absolute !important;
  z-index: 3;
  top: 10px !important;
  left: 10px !important;
  max-width: calc(100% - 20px);
  margin: 0;
  border-radius: 999px !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.single-product--template-overlay .category-badge {
  position: absolute !important;
  z-index: 3;
  top: 10px !important;
  right: 10px !important;
  left: auto !important;
  width: auto !important;
  margin: 0;
  border-radius: 999px !important;
}

@media (max-width: 575.98px) {
  .single-product--template-overlay > .click {
    border-radius: 23px;
  }

  .single-product--template-overlay .product-title {
    font-size: clamp(0.78rem, 3.4vw, 0.95rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .single-product--template-overlay > .click,
  .single-product--template-overlay .single-product-card img {
    transition: none;
  }
}

.single-product--category-showcase {
  height: 100%;
  --category-card-accent: #ed3446;
}

.single-product--category-showcase > .click {
  position: relative;
  display: flex;
  height: 100%;
  min-width: 0 !important;
  flex-direction: column;
  overflow: hidden;
  padding: 0 !important;
  border: 1px solid rgba(73, 91, 108, 0.12);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 14px 32px rgba(33, 52, 71, 0.11);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.single-product--category-showcase > .click:hover,
.single-product--category-showcase > .click:focus-visible {
  transform: translateY(-4px);
  box-shadow: 0 22px 42px rgba(33, 52, 71, 0.17);
}

.single-product--category-showcase > .click:focus-visible {
  outline: 3px solid var(--category-card-accent);
  outline-offset: 3px;
}

.single-product--category-showcase .single-product-card {
  width: 100%;
  max-width: none;
  margin: 0;
  overflow: hidden;
  border: 0 !important;
  aspect-ratio: 1.85 / 1;
  background: #e7eaec;
}

.single-product--category-showcase .single-product-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 320ms ease;
}

.single-product--category-showcase > .click:hover .single-product-card img {
  transform: scale(1.045);
}

.single-product--category-showcase .product-info {
  position: static !important;
  display: flex;
  min-width: 0;
  min-height: 172px;
  flex: 1;
  flex-direction: column;
  padding: 19px 22px 21px !important;
  background: linear-gradient(145deg, #fff 58%, #f7f9fb);
}

.single-product--category-showcase .badge-category {
  position: absolute !important;
  z-index: 3;
  top: 18px !important;
  left: 18px !important;
  max-width: calc(100% - 36px);
  overflow: hidden;
  padding: 8px 14px !important;
  border-radius: 999px !important;
  background: rgba(53, 72, 90, 0.88);
  color: #fff;
  font-size: 0.8rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  backdrop-filter: blur(8px);
}

.single-product--category-showcase .promo-badge,
.single-product--category-showcase .availability-badge,
.single-product--category-showcase .category-badge {
  position: absolute !important;
  z-index: 3;
  right: 18px !important;
  left: auto !important;
  width: auto !important;
  max-width: calc(100% - 36px);
  border-radius: 999px !important;
}

.single-product--category-showcase .promo-badge { top: 62px !important; }
.single-product--category-showcase .availability-badge { top: 106px !important; }
.single-product--category-showcase .category-badge { top: 150px !important; }

.single-product--category-showcase .product-name {
  order: 1;
  margin-bottom: 7px;
}

.single-product--category-showcase .product-title {
  display: -webkit-box;
  overflow: hidden;
  color: #2c4054;
  font-size: clamp(1.08rem, 1.65vw, 1.45rem);
  font-weight: 800;
  line-height: 1.14;
  letter-spacing: -0.025em;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.single-product--category-showcase .product-description {
  display: -webkit-box;
  order: 2;
  overflow: hidden;
  margin: 0 0 12px;
  color: #64758a;
  font-size: 0.9rem;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.single-product--category-showcase .product-price-badge {
  position: static !important;
  order: 3;
  align-self: flex-start;
  min-width: 0;
  margin: auto 0 0;
  padding: 9px 20px;
  border-radius: 999px !important;
  background: var(--category-card-accent);
  color: #fff;
  font-size: clamp(1.1rem, 1.6vw, 1.4rem);
  font-weight: 800;
  line-height: 1.1;
  box-shadow: 0 7px 16px rgba(237, 52, 70, 0.18);
}

.single-product--category-showcase .product-price-badge .text-secondary {
  color: rgba(255, 255, 255, 0.82) !important;
}

@media (max-width: 575.98px) {
  .single-product--category-showcase .product-info {
    min-height: 160px;
    padding: 16px 18px 18px !important;
  }

  .single-product--category-showcase .badge-category {
    top: 12px !important;
    left: 12px !important;
    margin: 0;
  }

  .single-product--category-showcase .promo-badge { top: 54px !important; }
  .single-product--category-showcase .availability-badge { top: 96px !important; }
  .single-product--category-showcase .category-badge { top: 138px !important; }
}

@media (prefers-reduced-motion: reduce) {
  .single-product--category-showcase > .click,
  .single-product--category-showcase .single-product-card img {
    transition: none;
  }
}
</style>
